import React  from 'react';
import { Container, Form, Button } from 'react-bootstrap';
import "react-datepicker/dist/react-datepicker.css";
import defaultProfile from "../assets/images/default-profile.png";
import profilePublic from "../assets/images/publicprofile.png";

const PublicProfile = () => {

  return (
    <div className='app-container mobile-bottom'>
      <Container className='mb-3'>

        <Form className='fs-12'>
          <div className='AccountInnerMain d-flex align-items-center justify-content-between'>
            <h6>
              <img src={profilePublic} width={20} alt="user" />
              <span className='ps-1'> Public Profile</span>
            </h6>
            <div className='uploadPic'>
              <div className='photo text-center'>
                <label htmlFor="file-upload" className='image_profile bg_dark_blue custom-file-upload'>
                  <img src={defaultProfile} alt="Profile Preview" />
                </label>
                <input id="file-upload" type="file" />
                <p className='mb-0 fs-10'>Upload Photo</p>
              </div>
            </div>
          </div>

          <Form.Group className="mb-3">
            <Form.Label>Bio</Form.Label>
            <Form.Control as="textarea" rows={3}  type="text" name="bio" className='border-2 fs-14' required />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Experiences</Form.Label>
            <Form.Control as="textarea" rows={2} type="text" name="exp" className='border-2 fs-14' required />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Awards</Form.Label>
            <Form.Control as="textarea" rows={2} type="text" className='border-2 fs-14' />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Certifications</Form.Label>
            <Form.Control as="textarea" rows={2} type="text" className='border-2 fs-14' />
          </Form.Group>
          

          <Form.Group className='d-flex justify-content-between'>
            <Button variant="danger" size='sm' type="submit" className='px-3 rounded-5 text-white'>
              Submit
            </Button>
          </Form.Group>
        </Form>
      </Container>
    </div>
  );
};

export default PublicProfile;
